export default function formatSeconds (seconds) {
  const date = new Date(0);
  const negative = seconds < 0;
  const prefix = negative ? '-' : '';
  const roundedSeconds = Math.round(negative ? seconds * -1 : seconds);
  date.setSeconds(roundedSeconds);
  return prefix + date.toISOString().substr(14, 5);
}
